module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAP1JREFUWEftlTEOAUEUhr9JWBqVcAqtSkfhEg6gkejEFqJaopa4hgtwAqVToNPIrngiUW3s7swyWcVMPfP+L/+8/z1FwUcVrI8DcA44B1IdCAPGAl7FZ5UU1yigI4pBWZgpn7NprFMBooCLQB3F2psy+lQ8XLBBGCo4lqBrCpEOsKQvD7ZANQlCAhp32Au08kBkNmFkGSIT4GW7TQgtAJsQ2gC2IIwA4hACk08RjTXmoezTToqnFYDrnGbVY/dOxu8AdJoxJn68hfRqc05fO6AjHp8JWeIvKK0vsCWuBZBH3GQk//coLnwZFb6OTXd7nvtaKchTWPeNA3AOOAeean3KId+htJAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/record/images/right.png
// module id = 1484
// module chunks = 0